import React from 'react';
import Collapse from '@material-ui/core/Collapse';
import Slide from '@material-ui/core/Slide';
import CloseRounded from '@material-ui/icons/CloseRounded';
import InfoRounded from '@material-ui/icons/InfoRounded';
import DoneOutlineRounded from '@material-ui/icons/DoneOutlineRounded';
import ErrorRounded from '@material-ui/icons/ErrorRounded';
import WarningRounded from '@material-ui/icons/WarningRounded';

import NotificationManager from '../..';
import classes from './styles.module.css';
import { path } from '../../../../utils';
import ThemedIconButton from '../../../Button/Icon';

export default class SnackbarManager extends NotificationManager {

    maxMessages = 3;
    queueShiftDelay = 0;

    render = () => <div className='bottomLeft messageIndex'>{this.state.messages.map(message =>
        <Slide key={message.id} in={message.visible} direction='right'
            onEntered={() => this._onMessageEntered(message)}
            onExited={() => this._removeMessageFromState(message.id)}>

            <div><Collapse in={message.visible}>
                {renderSnack(message, () => this._onMessageClose(message))}
            </Collapse></div>

        </Slide>
    )}</div>;

}

const renderSnack = (snack, onClose) => {
    const iconProps = { style: { height: 20, width: 20, color: 'white' }, className: classes.icon };
    const baseProps = { ...snack.props, content: snack.content, onClose };
    switch (path(snack.props, 'type')) {
        case 'info': return <Snack {...baseProps} className={classes.info} icon={<InfoRounded {...iconProps} />} />;
        case 'success': return <Snack {...baseProps} className={classes.success} icon={<DoneOutlineRounded {...iconProps} />} />;
        case 'error': return <Snack {...baseProps} className={classes.error} icon={<ErrorRounded {...iconProps} />} />;
        case 'warning': return <Snack {...baseProps} className={classes.warning} icon={<WarningRounded {...iconProps} />} />;
        case 'custom': default: return snack.content;
    }
};

export const Snack = React.memo(React.forwardRef(({ className = classes.info, icon, content, closeIcon, hideCloseIcon, ...props }, ref) =>
    <div className={className} {...props} ref={ref}>
        {icon != null ? icon : null}
        <div className={classes.content}><span>{content}</span></div>
        {!hideCloseIcon && <ThemedIconButton onClick={props.onClose} hoverRippleColor='#fff3' rippleColor='#ffffff80'>
            {closeIcon ? closeIcon : <CloseRounded style={{ color: 'white', height: 20, width: 20, opacity: 0.85 }} />}
        </ThemedIconButton>}
    </div>
));